import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GpdrInfoRedirectSheetComponent } from '@sc/ui-components';
import { GpdrInfoRedirectInputData } from '@sc/data-access-models';

@Component({
  selector: 'sc-gpdr-info-redirect-dialog',
  styleUrls: ['./gpdr-info-redirect-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [GpdrInfoRedirectSheetComponent],
  template: `
    <sc-gpdr-info-redirect-sheet
      (closeEvent)="onClose()"
      [redirectUrl]="data.redirectUrl"
    ></sc-gpdr-info-redirect-sheet>
  `,
})
export class GpdrInfoRedirectDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: GpdrInfoRedirectInputData,
    private readonly dialogRef: MatDialogRef<GpdrInfoRedirectDialogComponent>
  ) {}

  onClose() {
    this.dialogRef?.close();
  }
}
